export type RoutineChatView = 'canvas' | 'chat';

const getStorageKey = (routineId: string | number) =>
  `routine-chat-view:${routineId}`;

export const isRoutineChatView = (
  view: string | null
): view is RoutineChatView => view === 'canvas' || view === 'chat';

export const getSavedRoutineView = (
  routineId: string | number
): RoutineChatView => {
  if (typeof localStorage === 'undefined') return 'canvas';
  try {
    const view = localStorage.getItem(getStorageKey(routineId));
    return isRoutineChatView(view) ? view : 'canvas';
  } catch {
    return 'canvas';
  }
};

export const saveRoutineView = (
  routineId: string | number,
  view: RoutineChatView
) => {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(getStorageKey(routineId), view);
  } catch {
    // The URL still carries the active view when storage is unavailable.
  }
};
